module.exports = __webpack_public_path__ + "assets/img/bg.74170888.png";